import React from 'react'
import { IconButton } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'
import { makeStyles } from 'tss-react/mui'
import { Moment } from 'moment'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { J2Editacontent } from '@e3dc-react/icons'
import { TimeFrameList } from '../TimeFrameList'
import useModals from 'src/Hooks/useModals'
import { format } from 'date-fns'

const useStyles = makeStyles()(theme => ({
  accordion: {
    background: theme.palette.grey.grey07,
    borderColor: theme.palette.grey.grey06,
    padding: 0,

    '.MuiAccordionDetails-root': {
      padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    },
    '&.Mui-expanded , :not(&.Mui-expanded)': {
      marginBottom: theme.spacing(2),
    },
  },
}))

interface Props {
  dateFrameName: string
  onRemove: () => void
  hasWritingRights: boolean
}

const FORM_DEPTH = 1

/**
 * component to show and set date range and its time slots.
 */
const DateFrame: React.FC<Props> = ({ dateFrameName, onRemove, hasWritingRights }) => {
  const { classes } = useStyles()
  const methods = useFormContext()
  const { control, setValue } = methods
  const { openDynamicTariffSettingsDateRangeModal } = useModals()

  const fromDateField = `${dateFrameName}.from`
  const toDateField = `${dateFrameName}.to`
  const [from, to] = useWatch({ control, name: [fromDateField, toDateField] })

  const title = from && to ? `${format(new Date(from), 'dd.MM')}. - ${format(new Date(to), 'dd.MM')}.` : '--'

  const updateDateRange = (from?: Moment, to?: Moment): void => {
    setValue(fromDateField, from, { shouldValidate: true, shouldDirty: true, shouldTouch: true })
    setValue(toDateField, to, { shouldValidate: true, shouldDirty: true, shouldTouch: true })
  }

  const removeDateRange = (): void => {
    onRemove()
  }

  const handleEditIconClick = (e: React.MouseEvent): void => {
    openDynamicTariffSettingsDateRangeModal({ updateDateRange, from, to, removeDateRange })
  }

  return (
    <AccordionItem
      className={classes.accordion}
      elevation={0}
      expanded={true}
      depth={FORM_DEPTH}
      title={title}
      headerIcon={
        <IconButton disabled={!hasWritingRights} sx={{ color: 'grey.grey00' }} onClick={handleEditIconClick}>
          <J2Editacontent />
        </IconButton>
      }
    >
      <TimeFrameList dateFrameName={dateFrameName} hasWritingRights={hasWritingRights} />
    </AccordionItem>
  )
}

export default DateFrame
